import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'doubleChamiliElafronApostrofos';
const args = {};

export class DoubleChamiliElafronApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
